import { render, staticRenderFns } from "./picWatermark.vue?vue&type=template&id=45ac2d1a&scoped=true"
import script from "./picWatermark.vue?vue&type=script&lang=js"
export * from "./picWatermark.vue?vue&type=script&lang=js"
import style0 from "./picWatermark.vue?vue&type=style&index=0&id=45ac2d1a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac2d1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ac2d1a')) {
      api.createRecord('45ac2d1a', component.options)
    } else {
      api.reload('45ac2d1a', component.options)
    }
    module.hot.accept("./picWatermark.vue?vue&type=template&id=45ac2d1a&scoped=true", function () {
      api.rerender('45ac2d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/picWatermark.vue"
export default component.exports